import { useModalStore } from '@/shared/store/modalStore';
import type { PromptField } from '@/shared/store/modalStore';

export default function useModal() {
  const open = useModalStore((state) => state.open);

  return {
    alert: (message: string, noTitle = false, confirmText = '확인') => open('alert', message, noTitle, confirmText) as Promise<boolean>,
    confirm: (message: string, noTitle = false, confirmText = '확인', cancelText = '취소') =>
      open('confirm', message, noTitle, confirmText, cancelText) as Promise<boolean>,
    prompt: (message: string, fields: PromptField[] = [], noTitle = false, confirmText = '확인', cancelText = '취소') =>
      open('prompt', message, noTitle, confirmText, cancelText, fields) as Promise<string[] | false>,
  };
}
